import React, {PureComponent, ReactNode} from 'react';
import {inject} from 'mobx-react';
import BetSlipController from 'app/components/bet_slip/BetSlipController';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface BetSlipMenuControllerProps {
    controller?: BetSlipController
}


@inject('controller')
export default class BetSlipMenuController extends PureComponent<BetSlipMenuControllerProps> {
    handleMinimize = (): void => this.props.controller.setMinimize(true);

    betRemove = (): void => this.props.controller.removeAllGames();

    render(): ReactNode {
        return <div className="bet-slip-controller">
            <button className="bet-slip-controller-button draggable-coupon">
                <SpriteIcon name="#svg-bet-slip-controller-draggable" className="svg-default"/>
            </button>
            <button className="bet-slip-controller-button minimize-coupon" onClick={this.handleMinimize}>
                <SpriteIcon name="#svg-bet-slip-controller-minimize-1" className="svg-default"/>
            </button>
            <button className="bet-slip-controller-button close-coupon" onClick={this.betRemove}>
                <SpriteIcon name="#svg-bet-slip-controller-close" className="svg-default"/>
            </button>
        </div>;
    }
}
